<main>
  <!-- Carousel -->
  <section class="carousel-section">
    <div class="carousel-container">
      
      <!-- Boucle native Angular (pas besoin d'import) -->
      @for (slide of slides; track $index) {
        @if ($index === 0) {
            <div class="carousel-slide" [class.active]="$index === currentMainCarouselIndex">
                <div class="carousel-background" [style.backgroundImage]="'url(' + slideImage(slide) + ')'"></div>
                <div class="carousel-overlay"></div>
                <div class="container carousel-content">
                    <h1 [appTypewriter]="localized(slide, 'title') | translate" [speed]="80" [pause]="2500"></h1>
                    <p class="tagline subTitle" [appTypewriter]="localized(slide, 'text') | translate" [speed]="120" [pause]="3000"></p>
                </div>
            </div>
        }
        @else {
            <div class="carousel-slide" [class.active]="$index === currentMainCarouselIndex">
                <div class="carousel-background" [style.backgroundImage]="'url(' + slideImage(slide) + ')'"></div>
                <div class="carousel-overlay"></div>
                <div class="container carousel-content">
                    <h1>{{ localized(slide, 'title') | translate }}</h1>
                    <p class="tagline">{{ localized(slide, 'text') | translate }}</p>
                </div>
            </div>
        }
      }

      <!-- Contrôles flèches -->
      <button class="carousel-control prev" (click)="prevSlide()">&#10094;</button>
      <button class="carousel-control next" (click)="nextSlide()">&#10095;</button>

      <!-- Indicateurs (petits points) -->
      <div class="carousel-indicators">
        <!-- Boucle native Angular -->
        @for (slide of slides; track $index) {
          <span 
            class="dot" 
            [class.active]="$index === currentMainCarouselIndex" 
            (click)="goToSlide($index)">
          </span>
        }
      </div>
    </div>
  </section>

  <!-- Section des 3 blocs d'action -->
  <section class="action-blocks-section">
    <div class="container">
      <div class="blocks-grid">
        
        <div class="action-card bg-teal">
          <h3>{{ 'pages.core.home.home.text001' | translate }}</h3>
          <div class="separator"></div>
          <p>{{ 'pages.core.home.home.text002' | translate }}</p>
          <a routerLink="/qui-sommes-nous" class="btn-ghost">{{ 'pages.core.home.home.text003' | translate }}</a>
        </div>

        <div class="action-card bg-blue">
          <h3>{{ 'pages.core.home.home.text004' | translate }}</h3>
          <div class="separator"></div>
          <p>{{ 'pages.core.home.home.text005' | translate }}</p>
          <a href="/vision" class="btn-ghost">{{ 'pages.core.home.home.text006' | translate }}</a>
        </div>

        <div class="action-card bg-yellow">
          <h3>{{ 'pages.core.home.home.text007' | translate }}</h3>
          <div class="separator"></div>
          <p>{{ 'pages.core.home.home.text008' | translate }}</p>
          <a href="/fonctionnement" class="btn-ghost">{{ 'pages.core.home.home.text009' | translate }}</a>
        </div>

      </div>
    </div>
  </section>

  <!-- SECTION PROCHAINS ÉVÉNEMENTS -->
<!-- SECTION PROCHAINS ÉVÉNEMENTS (DÉFILEMENT RAPIDE) -->
<!-- SECTION LISTE DE TOUS LES ÉVÉNEMENTS -->
<!-- SECTION PROCHAINES RENCONTRES -->
<section class="upcoming-events-section">
  <div class="container">
    <h2 class="section-title">{{ 'pages.core.home.home.text010' | translate }}</h2>
    
    <div class="events-grid-full content-carousel-page" [attr.data-page]="currentEventCarouselIndex">
      @for (event of visibleEvents(); track event.id ?? $index) {
        <div class="event-card">
          <div class="event-date-badge">
            <span class="day">{{ eventDay(event) }}</span>
            <span class="month">{{ eventMonth(event) }}</span>
          </div>
          <div class="event-content">
            @if (event.logo_url) { <img class="content-logo" [src]="mediaUrl(event.logo_url)" [alt]="'Logo ' + localized(event, 'title')" (error)="hideBrokenImage($event)"> }
            <h3>{{ localized(event, 'title') | translate }}</h3>
            <p class="event-info">{{ eventInfo(event) | translate }}</p>
            @if (showEventDescription(event)) {
              <p class="event-desc">{{ eventDescription(event) | translate }}</p>
            }
            <!-- Le CTA ouvre désormais la page évènement AGBE complète ; le formulaire HelloAsso y est intégré. -->
            <a [routerLink]="eventPageUrl(event)" class="btn-event">{{ 'pages.core.home.home.text011' | translate }}</a>
          </div>
        </div>
      } @empty {
        <div class="events-empty">{{ 'pages.core.home.home.text015' | translate }}</div>
      }
    </div>
    @if (events.length > 1) {
      <div class="content-carousel-controls">
        <button type="button" aria-label="Événements précédents" (click)="changePage('events', -1)">‹</button>
        <div class="content-carousel-dots" aria-hidden="true">
          @for (pageIndex of pageIndexes(events); track pageIndex) { <span [class.active]="pageIndex === currentEventCarouselIndex"></span> }
        </div>
        <button type="button" aria-label="Événements suivants" (click)="changePage('events', 1)">›</button>
      </div>
    }
  </div>
</section>

<!-- SECTION : PROCHAINES RENCONTRES HEBDOMADAIRES -->
<section class="meetings-section">
  <div class="container">
    <h2 class="section-title">{{ 'pages.core.home.home.text016' | translate }}</h2>
    @if (meetings.length) {
      <div class="meetings-grid content-carousel-page" [attr.data-page]="currentMeetingCarouselIndex">
        @for (meeting of visibleMeetings(); track meeting.id ?? $index) {
          <article class="meeting-card">
            <div class="meeting-date">
              <span class="day">{{ eventDay(meeting) }}</span>
              <span class="month">{{ eventMonth(meeting) }}</span>
            </div>
            <div>
              @if (meeting.logo_url) { <img class="content-logo" [src]="mediaUrl(meeting.logo_url)" [alt]="'Logo ' + localized(meeting, 'title')" (error)="hideBrokenImage($event)"> }
              <p class="meeting-kicker">{{ 'pages.core.home.home.text017' | translate }}</p>
              <h3>{{ localized(meeting, 'title') }}</h3>
              @if (meeting.location) { <p class="meeting-location">📍 {{ meeting.location }}</p> }
              <p>{{ eventDescription(meeting) }}</p>
              @if (eventUrl(meeting) !== '#') {
                <a [href]="eventUrl(meeting)" target="_blank" rel="noopener noreferrer">{{ 'pages.core.home.home.text018' | translate }}</a>
              }
            </div>
          </article>
        }
      </div>
      @if (meetings.length > 1) {
        <div class="content-carousel-controls">
          <button type="button" aria-label="Rencontres précédentes" (click)="changePage('meetings', -1)">‹</button>
          <div class="content-carousel-dots" aria-hidden="true">
            @for (pageIndex of pageIndexes(meetings); track pageIndex) { <span [class.active]="pageIndex === currentMeetingCarouselIndex"></span> }
          </div>
          <button type="button" aria-label="Rencontres suivantes" (click)="changePage('meetings', 1)">›</button>
        </div>
      }
    } @else {
      <div class="meetings-empty">{{ 'pages.core.home.home.text019' | translate }}</div>
    }
  </div>
</section>

<!-- NOUVELLE SECTION : ACTUALITÉS -->
<section class="news-section">
  <div class="container">
    <div class="section-header-flex">
      <h2 class="section-title">{{ 'pages.core.home.home.text012' | translate }}</h2>
      <a routerLink="/actualites" class="view-all-link">{{ 'pages.core.home.home.text013' | translate }}</a>
    </div>

    <div class="news-grid content-carousel-page" [attr.data-page]="currentNewsCarouselIndex">
      @for (actualite of visibleNews(); track actualite.id ?? $index) {
        <div class="news-card">
          @if (actualite.logo_url) { <img class="content-logo" [src]="mediaUrl(actualite.logo_url)" [alt]="'Logo ' + localized(actualite, 'title')" (error)="hideBrokenImage($event)"> }
          <div class="news-content">
            <span class="news-date">{{ newsDate(actualite) }}</span>
            <h3>{{ localized(actualite, 'title') | translate }}</h3>
            <p>{{ localized(actualite, 'excerpt') | translate }}</p>
            <a [routerLink]="newsUrl(actualite)" class="read-more">{{ 'pages.core.home.home.text014' | translate }}</a>
          </div>
        </div>
      } @empty {
        <div class="news-empty">{{ 'pages.core.home.home.text020' | translate }}</div>
      }
    </div>
    @if (actualites.length > 1) {
      <div class="content-carousel-controls">
        <button type="button" aria-label="Actualités précédentes" (click)="changePage('news', -1)">‹</button>
        <div class="content-carousel-dots" aria-hidden="true">
          @for (pageIndex of pageIndexes(actualites); track pageIndex) { <span [class.active]="pageIndex === currentNewsCarouselIndex"></span> }
        </div>
        <button type="button" aria-label="Actualités suivantes" (click)="changePage('news', 1)">›</button>
      </div>
    }
  </div>
</section>
</main>